/* eslint-disable @next/next/no-img-element */
import Image from "next/image";

import classNames from "classnames";

import style from "./style.module.scss";

type ProfilePictureProps = {
  src: string;
  className?: string;
  border?: boolean | string;
  size?: number;
};

const ProfilePicture = ({
  src,
  className,
  border,
  size,
}: ProfilePictureProps) => {
  return (
    <div
      className={classNames(
        style.container,
        className,
        "rounded-full flex align-middle",
        border && "border border-solid border-black/20"
      )}
    >
      <Image
        alt="profile avatar"
        src={src}
        width={size ? size - 2 - (border ? 2 : 0) : 35 - (border ? 2 : 0)}
        height={size ? size - 2 - (border ? 2 : 0) : 35 - (border ? 2 : 0)}
        priority
      />
    </div>
  );
};

export default ProfilePicture;
